<app-nav></app-nav>

<section class="aboutUs">
  <div class="container">
    <div class="page_progress">
      <h5 class="comments_dash">Comments</h5>
      <ul class="StepProgress ll1">
       
      
        <li class="hand"> 
          <!-- <strong>{{paid}}</strong> -->
          
          <div *ngIf="this.showpaid">
            <div class="col-6" *ngIf="this.approvedAmount">
              <!-- <div class="row cardFields">Approved Amount</div> -->
              <div class="approv_amount" >Amount :- {{this.approvedAmount}}</div>
            </div>
  
          </div>
            

          <span class="comment_amount">{{claimstatuscomment}}</span>

          <ul class="ll1">
            <!-- <li class="StepProgress-item1"><b>Claim Number :- {{AcknowledgedByinsurer}}</b>

            </li> -->


          </ul>
              
</li>
      
      </ul>

      </div>
  </div>
</section>


  <!-- <section class="aboutUs">

    <h5 class="comments_dash" style="margin-top: 10px;">Comment History</h5>
    <div class="container">
      <div class="page_progress">
        <h5 class="comments_dash">Comments</h5>
        <ul class="StepProgress">
         
        
          <li class="hand"> <strong>{{Acknowledged}}</strong>

            <ul class="ll1">
              <li class="StepProgress-item1"><b>Claim Number :- {{AcknowledgedByinsurer}}</b>
               
              </li>
             
            </ul>
                
</li>
        
        </ul>

        </div>
    </div>
  </section> -->


  <!-- <section class="aboutUs">
    <div class="container">
      <div class="page_progress">
        <h5 class="comments_dash">Documents</h5>
        <ul class="StepProgress">
         
        
          <li class="hand"> <strong>{{Acknowledgeds}}</strong>

            <span class="handover2">No Of Documents </span>
            
            <ul class="ll1" *ngFor="let item of getdocumentss">
              <li class="StepProgress-item1"><b>{{item.name}}</b>
                <span class="StepProgress-item1 count2"><b>{{item.count}}</b></span>
                
              </li>
              

            </ul>
                
</li>
        
        </ul>

        </div>
    </div>
  </section> -->

  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>